const proceedingParticipants = {
  createParticipant: "Verfahrensbeteiligte anlegen",
  noResults:
    "Mit den aktuellen Suchkriterien konnten keine Verfahrensbeteiligten gefunden werden. \nBitte überprüfen Sie ihre Suchangaben und Filter.",
  moreResults: "Es gibt noch weitere Verfahrensbeteiligte die aufgrund der Limitierung nicht angezeigt werden",
  searchPlaceholder: "Verfahrensbeteiligte finden",
  clientSpecificBadge: "KUNDENSPEZ.",
  showInactive: "Inaktive anzeigen",
  types: {
    Creditor: "Gläubiger",
    LawFirm: "Rechtsanwalts-Kanzlei",
    DebtCollectionAgency: "Inkasso-Büro",
    Trustee: "Treuhänder",
    InsolvencyAdministrator: "Masseverwalter",
    Organisation: "Organisation",
    Bank: "Bank",
    Insurance: "Versicherung",
  },
  table: {
    name: "Name",
    type: "Art",
    address: "Straße, Nr.",
    zipCode: "PLZ",
    city: "Ort",
    inactiveSince: "Inaktiv seit",
  },
  create: {
    dialogTitle: "Verfahrensbeteiligter anlegen",
    clientSpecificDialogTitle: "Kundenspezifischen Verfahrensbeteiligten anlegen",
    clientSpecificSubtitle: "Wird nur für diesen Kunden gespeichert.",
    successfullyCreated: "Verfahrensbeteiligter wurde erfolgreich angelegt",
    type: "Art",
    name: "Name",
    note: "Anmerkung",
    invalidZipCode: "Die Postleitzahl muss numerisch sein",
    alsoCreateGlobal: "Als globalen Verfahrensbeteiligten anlegen",
    alsoCreateGlobalHelper: "Steht damit allen Kund:innen zur Verfügung (Systemeinstellungen › Verfahrensbeteiligte).",
  },
  edit: {
    dialogTitle: "Verfahrensbeteiligter bearbeiten",
    viewDialogTitle: "Verfahrensbeteiligter ansehen",
    successfullyUpdated: "Verfahrensbeteiligter wurde erfolgreich aktualisiert",
    lastChanged: "Letzte Änderung am {{date}} von {{user}}",
    deactivate: "Inaktiv setzen",
    reactivate: "Aktiv setzen",
    inactiveBanner:
      "Inaktiv gesetzt · {{date}} — {{user}}.\nSchreibgeschützt. Eintrag steht für neue Verknüpfungen nicht mehr zur Auswahl; bestehende Verknüpfungen bleiben erhalten.",
    inactiveBannerNoUser:
      "Inaktiv gesetzt · {{date}}.\nSchreibgeschützt. Eintrag steht für neue Verknüpfungen nicht mehr zur Auswahl; bestehende Verknüpfungen bleiben erhalten.",
    deactivationReasonLabel: "Begründung",
  },
  deactivate: {
    dialogTitle: "Eintrag inaktiv setzen?",
    dialogBody:
      "<strong>{{participantName}}</strong> wird auf inaktiv gesetzt und steht für neue Forderungen, Vertretungen oder Inkassobeauftragungen nicht mehr zur Auswahl. Bestehende Verknüpfungen bleiben erhalten.",
    reasonLabel: "Begründung",
    reasonPlaceholder: "Warum soll dieser Eintrag inaktiv gesetzt werden?",
    reasonRequired: "Bitte geben Sie eine Begründung an.",
    activeClaimsWarning_one:
      "Dieser Verfahrensbeteiligte wird derzeit noch bei <strong>{{count}} aktiven Forderung</strong> verwendet. Bestehende Verknüpfungen bleiben erhalten — der Eintrag steht nur für neue Verknüpfungen nicht mehr zur Auswahl.",
    activeClaimsWarning_other:
      "Dieser Verfahrensbeteiligte wird derzeit noch bei <strong>{{count}} aktiven Forderungen</strong> verwendet. Bestehende Verknüpfungen bleiben erhalten — der Eintrag steht nur für neue Verknüpfungen nicht mehr zur Auswahl.",
    confirmButton: "Inaktiv setzen",
    cancelButton: "Abbrechen",
    successfullyDeactivated: "Verfahrensbeteiligter wurde erfolgreich inaktiv gesetzt.",
  },
  reactivate: {
    dialogTitle: "Eintrag wieder aktiv setzen?",
    dialogBody:
      '„{{participantName}}" wird wieder aktiv. Der Eintrag steht damit wieder für neue Verknüpfungen zur Auswahl.',
    previousReason: "Bisheriger Grund: {{reason}}",
    confirmButton: "Aktiv setzen",
    cancelButton: "Abbrechen",
    successfullyReactivated: "Verfahrensbeteiligter wurde wieder aktiv gesetzt.",
  },
  merge: {
    button: "Fusionieren",
    endButton: "Fusionieren beenden",
    selectionCount_one: "{{count}} ausgewählt",
    selectionCount_other: "{{count}} ausgewählt",
    differentTypesHint: "Alle ausgewählten Verfahrensbeteiligten müssen die gleiche Art haben.",
    maxSelectionWarning: "Es können nur {{max}} Einträge miteinander fusioniert werden.",
    clearSelection: "Auswahl aufheben",
    dialogTitle: "Verfahrensbeteiligte fusionieren",
    dialogIntro:
      "Welcher Verfahrensbeteiligte soll bestehen bleiben? Der andere Eintrag wird inaktiv gesetzt und alle bisherigen Verknüpfungen (Forderungen, Vertretungen, Inkassobeauftragungen) werden auf den ausgewählten Eintrag übertragen.",
    existsBadge: "BESTEHT",
    sourcesWarning:
      '„{{source}}" wird auf inaktiv gesetzt und steht für neue Verknüpfungen nicht mehr zur Auswahl. Bestehende Verknüpfungen werden auf „{{destination}}" übertragen.',
    confirmButton: "Fusionieren",
    cancelButton: "Abbrechen",
    confirmDialogTitle: "Verfahrensbeteiligte fusionieren?",
    confirmBody:
      'Sind Sie sicher, dass „{{source}}" mit „{{destination}}" fusioniert werden soll? Dies kann nicht rückgängig gemacht werden.',
    success: "Fusion wurde erfolgreich durchgeführt.",
    historyLabel: "Fusionshistorie",
  },
};

export default proceedingParticipants;
